<div class="even">
    <mat-label class="subHeading">Renewal</mat-label>
    <button class="side" (click)="form.controls['renewal'].setValue(null);">Remove</button>
    </div><mat-select class="renew" formControlName="renewal" placeholder="All">
    <mat-option value="first_year">First Year</mat-option>
    <mat-option value="second_year_onwards">Second Year Onwards</mat-option>
</mat-select>